<template>
    <LabelMenu style="color:#888;"
        :value="value[schema.name]" 
        @change="$emit('change', $event)"
        :label="schema.label"  
        :menus="schema.items"
        underline="black"
    />
</template>

<script>

import LabelMenu from '@/ui-elements/LabelMenu'

export default {

    data() {
        return {
        
        }
    },

    components: {
        LabelMenu,
    },
    
    props: {
        value: Object,
        schema: Object, 
    },

    computed: {
        hideDetails() {
            if(this.schema.compact)
                return true

            else
                return false
        }
    },

    methods: {
        change(newVal) {
            this.value[this.schema.name] = newVal
            
        }
    },

    created() {

    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// DropdownLabelControl.vue?60058286